import CloseModal from 'actions/modal/close_modal';
import { handleCommonErrors } from 'scripts/application/lib/gateway_error_interactive_handler';
import ShowToast from 'actions/toast_deprecated/show_toast';
import { ToastType } from 'models/toast_deprecated';

export default class RedactTaskComment {
  constructor(context) {
    this.context = context;
  }

  run({ itemId, commentId }) {
    this.context.executeAction(CloseModal);

    let taskInfo = this.context.stores.taskInfo.find(itemId);
    taskInfo.comments[commentId].redact();
    this.context.stores.taskInfo.setPending(taskInfo);

    this.context.gateways.taskCommentRedaction
      .add({ taskId: itemId, commentId }, {})
      .then(() => {
        this.context.stores.taskInfo.commitPending(itemId);
        this.context.executeAction(ShowToast, {
          type: ToastType.SUCCESS,
          message: 'Comment deleted.',
        });
      })
      .catch(err => {
        this.context.stores.taskInfo.resetPending(itemId);
        handleCommonErrors(this.context, err);
      });
  }
}
